// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ge-scene-explorer-host {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
}
#ge-scene-explorer-host * {
  font-family: "acumin-pro-condensed";
}
#ge-scene-explorer-host:focus {
  outline: none;
}

#ge-__resizable_base__ {
  display: none;
}

.ge-context-menu {
  background: #e2e2e2;
}
.ge-context-menu .react-contextmenu-item {
  padding: 10px;
  cursor: pointer;
}
.ge-context-menu .react-contextmenu-item:hover {
  background: #e2e2e2;
}

.ge-eact-contextmenu.context-menu.react-contextmenu--visible {
  z-index: 99;
  transform: scale(1);
}

#ge-sceneExplorer {
  background: #e2e2e2;
  height: 100%;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  font: 16px "acumin-pro-condensed";
}
#ge-sceneExplorer:focus {
  outline: none;
}
#ge-sceneExplorer #header {
  height: 30px;
  font-size: 16px;
  color: black;
  background: #e2e2e2;
  grid-row: 1;
  text-align: center;
  display: grid;
  grid-template-columns: 30px 1fr 50px;
  user-select: none;
}
#ge-sceneExplorer #header #logo {
  position: relative;
  grid-column: 1;
  width: 24px;
  height: 24px;
  left: 0;
  display: flex;
  align-self: center;
  justify-self: center;
}
#ge-sceneExplorer #header #title {
  grid-column: 2;
  display: grid;
  align-items: center;
  text-align: center;
}
#ge-sceneExplorer #header #commands {
  grid-column: 3;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}
#ge-sceneExplorer #header #commands .expand {
  grid-column: 1;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#ge-sceneExplorer #header #commands .close {
  grid-column: 2;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#ge-sceneExplorer #tree {
  grid-row: 2;
  overflow-x: hidden;
  overflow-y: auto;
}
#ge-sceneExplorer .filter {
  display: flex;
  align-items: stretch;
}
#ge-sceneExplorer .filter input {
  width: 100%;
  margin: 10px 40px 5px 40px;
  display: block;
  border: none;
  padding: 0;
  border-bottom: solid 1px rgb(51, 122, 183);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, rgb(51, 122, 183) 4%);
  background-position: -1000px 0;
  background-size: 1000px 100%;
  background-repeat: no-repeat;
  color: black;
}
#ge-sceneExplorer .filter input::placeholder {
  color: lightgray;
}
#ge-sceneExplorer .filter input:focus {
  box-shadow: none;
  outline: none;
  background-position: 0 0;
}
#ge-sceneExplorer .groupContainer {
  margin-left: 0px;
  color: black;
  margin-top: 0px;
  margin-bottom: 0px;
  height: 24px;
  user-select: none;
  align-self: center;
  display: grid;
  align-items: center;
}
#ge-sceneExplorer .groupContainer:hover {
  background: #bbbbbb;
}
#ge-sceneExplorer .groupContainer .expandableHeader {
  display: grid;
  grid-template-columns: 1fr 20px;
}
#ge-sceneExplorer .groupContainer .expandableHeader .text {
  grid-column: 1;
  display: grid;
  grid-template-columns: 20px 1fr;
}
#ge-sceneExplorer .groupContainer .expandableHeader .text .arrow {
  grid-column: 1;
  margin-left: 0px;
  color: black;
  cursor: pointer;
  display: inline-block;
  margin-right: 6px;
  opacity: 0.5;
}
#ge-sceneExplorer .groupContainer .expandableHeader .text .text-value {
  grid-column: 2;
  display: flex;
  align-items: center;
}
#ge-sceneExplorer .groupContainer .expandableHeader .expandAll {
  opacity: 0.5;
  grid-column: 2;
  margin-right: 10px;
}
#ge-sceneExplorer .icon {
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#ge-sceneExplorer .addComponent {
  display: none;
}
#ge-sceneExplorer .makeChild {
  grid-column: 3;
}
#ge-sceneExplorer .itemContainer {
  margin-left: 0px;
  color: black;
  margin-top: 0px;
  margin-bottom: 0px;
  height: 32px;
  -webkit-user-select: none;
  user-select: none;
  display: grid;
  grid-template-columns: 20px 1fr;
  border: 2px solid transparent;
}
#ge-sceneExplorer .itemContainer.hover {
  border: 2px solid #527089;
  cursor: pointer;
}
#ge-sceneExplorer .itemContainer.seAbove {
  border-top: 2px solid #527089;
  cursor: pointer;
}
#ge-sceneExplorer .itemContainer.seBelow {
  border-bottom: 2px solid #527089;
  cursor: pointer;
}
#ge-sceneExplorer .itemContainer.selected {
  background: #bfbebe;
  color: black;
}
#ge-sceneExplorer .itemContainer.dragged {
  background: transparent;
  color: black;
}
#ge-sceneExplorer .itemContainer.parent {
  background: #ffffff;
  color: black;
}
#ge-sceneExplorer .itemContainer .isNotActive {
  opacity: 0.3;
}
#ge-sceneExplorer .itemContainer .arrow {
  grid-column: 1;
  color: black;
  opacity: 0.6;
}
#ge-sceneExplorer .itemContainer .popup {
  width: 200px;
  visibility: hidden;
  background-color: #bbbbbb;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  position: absolute;
  z-index: 1;
  margin-left: -180px;
  box-sizing: border-box;
}
#ge-sceneExplorer .itemContainer .popup.show {
  visibility: visible;
}
#ge-sceneExplorer .itemContainer .popup:focus {
  outline: none;
}
#ge-sceneExplorer .itemContainer .popup .popupMenu {
  padding: 6px 5px 5px 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 18px;
}
#ge-sceneExplorer .itemContainer .popup .popupMenu:hover {
  background: white;
  color: #333333;
}
#ge-sceneExplorer .itemContainer .sceneNode {
  grid-column: 2;
  margin-left: -10px;
  display: grid;
  grid-template-columns: 1fr 20px 20px 20px 20px 10px 20px 20px auto 5px;
  align-items: center;
  cursor: pointer;
}
#ge-sceneExplorer .itemContainer .sceneNode .sceneTitle {
  grid-column: 1;
  margin-right: 5px;
  display: flex;
  align-items: center;
  height: 24px;
}
#ge-sceneExplorer .itemContainer .sceneNode .translation {
  grid-column: 2;
  opacity: 0.6;
}
#ge-sceneExplorer .itemContainer .sceneNode .translation.selected {
  opacity: 1;
}
#ge-sceneExplorer .itemContainer .sceneNode .rotation {
  grid-column: 3;
  opacity: 0.6;
}
#ge-sceneExplorer .itemContainer .sceneNode .rotation.selected {
  opacity: 1;
}
#ge-sceneExplorer .itemContainer .sceneNode .scaling {
  grid-column: 4;
  opacity: 0.6;
}
#ge-sceneExplorer .itemContainer .sceneNode .scaling.selected {
  opacity: 1;
}
#ge-sceneExplorer .itemContainer .sceneNode .bounding {
  grid-column: 5;
  opacity: 0.6;
}
#ge-sceneExplorer .itemContainer .sceneNode .bounding.selected {
  opacity: 1;
}
#ge-sceneExplorer .itemContainer .sceneNode .separator {
  grid-column: 6;
  margin-left: 5px;
  width: 5px;
  display: flex;
  align-items: center;
  height: 18px;
  border-left: solid 1px rgb(51, 122, 183);
}
#ge-sceneExplorer .itemContainer .sceneNode .pickingMode {
  grid-column: 7;
  opacity: 0.6;
}
#ge-sceneExplorer .itemContainer .sceneNode .pickingMode.selected {
  opacity: 1;
}
#ge-sceneExplorer .itemContainer .sceneNode .refresh {
  grid-column: 8;
}
#ge-sceneExplorer .itemContainer .sceneNode .extensions {
  width: 20px;
  grid-column: 9;
}
#ge-sceneExplorer .itemContainer .adtextureTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr 20px auto 5px;
  align-items: center;
}
#ge-sceneExplorer .itemContainer .adtextureTools .pickingMode {
  grid-column: 2;
  opacity: 0.6;
}
#ge-sceneExplorer .itemContainer .adtextureTools .pickingMode.selected {
  opacity: 1;
}
#ge-sceneExplorer .itemContainer .adtextureTools .extensions {
  width: 20px;
  grid-column: 3;
}
#ge-sceneExplorer .itemContainer .controlTools {
  grid-column: 2;
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr auto auto auto;
}
#ge-sceneExplorer .itemContainer .controlTools .controlType {
  grid-column: 1;
}
#ge-sceneExplorer .itemContainer .controlTools .controlType img {
  width: 32px;
  height: 32px;
  filter: invert(100%);
}
#ge-sceneExplorer .itemContainer .controlTools .highlight {
  grid-column: 3;
}
#ge-sceneExplorer .itemContainer .controlTools .visibility {
  grid-column: 4;
}
#ge-sceneExplorer .itemContainer .controlTools .extensions {
  width: 20px;
  grid-column: 5;
}
#ge-sceneExplorer .itemContainer .title {
  background: transparent;
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
  margin-right: 5px;
  align-items: center;
  height: 24px;
  cursor: pointer;
}
#ge-sceneExplorer .itemContainer .title .titleText {
  font-family: "acumin-pro-condensed", sans-serif;
  font-size: 16px;
  border: unset;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./../../../tools/guiEditor/dist/components/sceneExplorer/sceneExplorer.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AACJ;AAAI;EACI,mCAAA;AAER;AAAI;EACI,aAAA;AAER;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;AACI;EACI,aAAA;EACA,eAAA;AACR;AACQ;EACI,mBAAA;AACZ;;AAIA;EACI,WAAA;EACA,mBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;EACA,iCAAA;AADJ;AAGI;EACI,aAAA;AADR;AAII;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,iBAAA;AAFR;AAIQ;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AAFZ;AAKQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAHZ;AAMQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAJZ;AAMY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAJhB;AAOY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AALhB;AAUI;EACI,WAAA;EAEA,kBAAA;EACA,gBAAA;AATR;AAYI;EACI,aAAA;EACA,oBAAA;AAVR;AAYQ;EACI,WAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EACA,wFAAA;EACA,8BAAA;EACA,4BAAA;EACA,4BAAA;EACA,YAAA;AAVZ;AAaQ;EACI,gBAAA;AAXZ;AAcQ;EACI,gBAAA;EACA,aAAA;EACA,wBAAA;AAZZ;AAgBI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EAEA,iBAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;AAhBR;AAkBQ;EACI,mBAAA;AAhBZ;AAmBQ;EACI,aAAA;EACA,+BAAA;AAjBZ;AAmBY;EACI,cAAA;EACA,aAAA;EACA,+BAAA;AAjBhB;AAmBgB;EACI,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAjBpB;AAoBgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAlBpB;AAsBY;EACI,YAAA;EACA,cAAA;EACA,kBAAA;AApBhB;AAyBI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAvBR;AA0BI;EACI,aAAA;AAxBR;AA2BI;EACI,cAAA;AAzBR;AA4BI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,+BAAA;EACA,6BAAA;AA1BR;AA2BQ;EACI,yBAAA;EACA,eAAA;AAzBZ;AA4BQ;EACI,6BAAA;EACA,eAAA;AA1BZ;AA4BQ;EACI,gCAAA;EACA,eAAA;AA1BZ;AA6BQ;EACI,mBAAA;EACA,YAAA;AA3BZ;AA8BQ;EACI,uBAAA;EACA,YAAA;AA5BZ;AA+BQ;EACI,mBAAA;EACA,YAAA;AA7BZ;AAgCQ;EACI,YAAA;AA9BZ;AAgCQ;EACI,cAAA;EACA,YAAA;EACA,YAAA;AA9BZ;AAiCQ;EACI,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;AA/BZ;AAiCY;EACI,mBAAA;AA/BhB;AAkCY;EACI,aAAA;AAhChB;AAmCY;EACI,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAjChB;AAmCgB;EACI,iBAAA;EACA,cAAA;AAjCpB;AAsCQ;EACI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sEAAA;EACA,mBAAA;EACA,eAAA;AApCZ;AAsCY;EACI,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AApChB;AAuCY;EACI,cAAA;EACA,YAAA;AArChB;AAuCgB;EACI,UAAA;AArCpB;AAyCY;EACI,cAAA;EACA,YAAA;AAvChB;AAyCgB;EACI,UAAA;AAvCpB;AA2CY;EACI,cAAA;EACA,YAAA;AAzChB;AA0CgB;EACI,UAAA;AAxCpB;AA4CY;EACI,cAAA;EACA,YAAA;AA1ChB;AA2CgB;EACI,UAAA;AAzCpB;AA6CY;EACI,cAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;AA3ChB;AA8CY;EACI,cAAA;EACA,YAAA;AA5ChB;AA8CgB;EACI,UAAA;AA5CpB;AAgDY;EACI,cAAA;AA9ChB;AAiDY;EACI,WAAA;EACA,cAAA;AA/ChB;AAmDQ;EACI,cAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;AAjDZ;AAmDY;EACI,cAAA;EACA,YAAA;AAjDhB;AAmDgB;EACI,UAAA;AAjDpB;AAqDY;EACI,WAAA;EACA,cAAA;AAnDhB;AAuDQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8CAAA;AArDZ;AAuDY;EACI,cAAA;AArDhB;AAsDgB;EACI,WAAA;EACA,YAAA;EACA,oBAAA;AApDpB;AAwDY;EACI,cAAA;AAtDhB;AAyDY;EACI,cAAA;AAvDhB;AA0DY;EACI,WAAA;EACA,cAAA;AAxDhB;AA4DQ;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AA1DZ;AA4DY;EACI,+CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AA1DhB","sourcesContent":["#ge-scene-explorer-host {\r\n    position: absolute;\r\n    left: 0px;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    * {\r\n        font-family: \"acumin-pro-condensed\";\r\n    }\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n}\r\n\r\n#ge-__resizable_base__ {\r\n    display: none;\r\n}\r\n\r\n.ge-context-menu {\r\n    background: #e2e2e2;\r\n\r\n    .react-contextmenu-item {\r\n        padding: 10px;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background: #e2e2e2;\r\n        }\r\n    }\r\n}\r\n\r\n.ge-eact-contextmenu.context-menu.react-contextmenu--visible {\r\n    z-index: 99;\r\n    transform: scale(1);\r\n}\r\n\r\n#ge-sceneExplorer {\r\n    background: #e2e2e2;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: grid;\r\n    grid-template-rows: auto 1fr;\r\n    font: 16px \"acumin-pro-condensed\";\r\n\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n\r\n    #header {\r\n        height: 30px;\r\n        font-size: 16px;\r\n        color: black;\r\n        background: #e2e2e2;\r\n        grid-row: 1;\r\n        text-align: center;\r\n        display: grid;\r\n        grid-template-columns: 30px 1fr 50px;\r\n        user-select: none;\r\n\r\n        #logo {\r\n            position: relative;\r\n            grid-column: 1;\r\n            width: 24px;\r\n            height: 24px;\r\n            left: 0;\r\n            display: flex;\r\n            align-self: center;\r\n            justify-self: center;\r\n        }\r\n\r\n        #title {\r\n            grid-column: 2;\r\n            display: grid;\r\n            align-items: center;\r\n            text-align: center;\r\n        }\r\n\r\n        #commands {\r\n            grid-column: 3;\r\n            display: grid;\r\n            align-items: center;\r\n            grid-template-columns: 1fr 1fr;\r\n\r\n            .expand {\r\n                grid-column: 1;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n\r\n            .close {\r\n                grid-column: 2;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    #tree {\r\n        grid-row: 2;\r\n\r\n        overflow-x: hidden;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .filter {\r\n        display: flex;\r\n        align-items: stretch;\r\n\r\n        input {\r\n            width: 100%;\r\n            margin: 10px 40px 5px 40px;\r\n            display: block;\r\n            border: none;\r\n            padding: 0;\r\n            border-bottom: solid 1px rgb(51, 122, 183);\r\n            background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, rgb(51, 122, 183) 4%);\r\n            background-position: -1000px 0;\r\n            background-size: 1000px 100%;\r\n            background-repeat: no-repeat;\r\n            color: black;\r\n        }\r\n\r\n        input::placeholder {\r\n            color: lightgray;\r\n        }\r\n\r\n        input:focus {\r\n            box-shadow: none;\r\n            outline: none;\r\n            background-position: 0 0;\r\n        }\r\n    }\r\n\r\n    .groupContainer {\r\n        margin-left: 0px;\r\n        color: black;\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n        height: 24px;\r\n\r\n        user-select: none;\r\n\r\n        align-self: center;\r\n        display: grid;\r\n        align-items: center;\r\n\r\n        &:hover {\r\n            background: #bbbbbb;\r\n        }\r\n\r\n        .expandableHeader {\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px;\r\n\r\n            .text {\r\n                grid-column: 1;\r\n                display: grid;\r\n                grid-template-columns: 20px 1fr;\r\n\r\n                .arrow {\r\n                    grid-column: 1;\r\n                    margin-left: 0px;\r\n                    color: black;\r\n                    cursor: pointer;\r\n                    display: inline-block;\r\n                    margin-right: 6px;\r\n                    opacity: 0.5;\r\n                }\r\n\r\n                .text-value {\r\n                    grid-column: 2;\r\n                    display: flex;\r\n                    align-items: center;\r\n                }\r\n            }\r\n\r\n            .expandAll {\r\n                opacity: 0.5;\r\n                grid-column: 2;\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .icon {\r\n        display: grid;\r\n        align-items: center;\r\n        justify-items: center;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .addComponent {\r\n        display: none;\r\n    }\r\n\r\n    .makeChild {\r\n        grid-column: 3;\r\n    }\r\n\r\n    .itemContainer {\r\n        margin-left: 0px;\r\n        color: black;\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n        height: 32px;\r\n        -webkit-user-select: none;\r\n        user-select: none;\r\n        display: grid;\r\n        grid-template-columns: 20px 1fr;\r\n        border: 2px solid transparent;\r\n        &.hover {\r\n            border: 2px solid #527089;\r\n            cursor: pointer;\r\n        }\r\n\r\n        &.seAbove {\r\n            border-top: 2px solid #527089;\r\n            cursor: pointer;\r\n        }\r\n        &.seBelow {\r\n            border-bottom: 2px solid #527089;\r\n            cursor: pointer;\r\n        }\r\n\r\n        &.selected {\r\n            background: #bfbebe;\r\n            color: black;\r\n        }\r\n\r\n        &.dragged {\r\n            background: transparent;\r\n            color: black;\r\n        }\r\n\r\n        &.parent {\r\n            background: #ffffff;\r\n            color: black;\r\n        }\r\n\r\n        .isNotActive {\r\n            opacity: 0.3;\r\n        }\r\n        .arrow {\r\n            grid-column: 1;\r\n            color: black;\r\n            opacity: 0.6;\r\n        }\r\n\r\n        .popup {\r\n            width: 200px;\r\n            visibility: hidden;\r\n            background-color: #bbbbbb;\r\n            color: #fff;\r\n            border: 1px solid rgba(255, 255, 255, 0.5);\r\n            position: absolute;\r\n            z-index: 1;\r\n            margin-left: -180px;\r\n            box-sizing: border-box;\r\n\r\n            &.show {\r\n                visibility: visible;\r\n            }\r\n\r\n            &:focus {\r\n                outline: none;\r\n            }\r\n\r\n            .popupMenu {\r\n                padding: 6px 5px 5px 10px;\r\n                overflow: hidden;\r\n                white-space: nowrap;\r\n                text-overflow: ellipsis;\r\n                height: 18px;\r\n\r\n                &:hover {\r\n                    background: white;\r\n                    color: #333333;\r\n                }\r\n            }\r\n        }\r\n\r\n        .sceneNode {\r\n            grid-column: 2;\r\n            margin-left: -10px;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px 20px 20px 20px 10px 20px 20px auto 5px;\r\n            align-items: center;\r\n            cursor: pointer;\r\n\r\n            .sceneTitle {\r\n                grid-column: 1;\r\n                margin-right: 5px;\r\n                display: flex;\r\n                align-items: center;\r\n                height: 24px;\r\n            }\r\n\r\n            .translation {\r\n                grid-column: 2;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .rotation {\r\n                grid-column: 3;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .scaling {\r\n                grid-column: 4;\r\n                opacity: 0.6;\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .bounding {\r\n                grid-column: 5;\r\n                opacity: 0.6;\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .separator {\r\n                grid-column: 6;\r\n                margin-left: 5px;\r\n                width: 5px;\r\n                display: flex;\r\n                align-items: center;\r\n                height: 18px;\r\n                border-left: solid 1px rgb(51, 122, 183);\r\n            }\r\n\r\n            .pickingMode {\r\n                grid-column: 7;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .refresh {\r\n                grid-column: 8;\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 9;\r\n            }\r\n        }\r\n\r\n        .adtextureTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px auto 5px;\r\n            align-items: center;\r\n\r\n            .pickingMode {\r\n                grid-column: 2;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 3;\r\n            }\r\n        }\r\n\r\n        .controlTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            align-items: center;\r\n            grid-template-columns: auto 1fr auto auto auto;\r\n\r\n            .controlType {\r\n                grid-column: 1;\r\n                img {\r\n                    width: 32px;\r\n                    height: 32px;\r\n                    filter: invert(100%);\r\n                }\r\n            }\r\n\r\n            .highlight {\r\n                grid-column: 3;\r\n            }\r\n\r\n            .visibility {\r\n                grid-column: 4;\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 5;\r\n            }\r\n        }\r\n\r\n        .title {\r\n            background: transparent;\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n            min-width: 0;\r\n            margin-right: 5px;\r\n            align-items: center;\r\n            height: 24px;\r\n            cursor: pointer;\r\n\r\n            .titleText {\r\n                font-family: \"acumin-pro-condensed\", sans-serif;\r\n                font-size: 16px;\r\n                border: unset;\r\n                white-space: nowrap;\r\n                text-overflow: ellipsis;\r\n                overflow: hidden;\r\n                outline: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
